module.exports = __webpack_public_path__ + "static/about-us-cai-7f83274c1f41e097b0a6a3fee0516054.png";